module.exports = __webpack_public_path__ + "produce-fresh-grass-06.jpg?6d30e76e7a956ca089c8a75b776aff38";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-06.jpg
// module id = 43
// module chunks = 0